import React from "react";
import Input from "../../../../../components/FormComponents/Input";
import { useAppBlocksContext } from "../../../../../context/AppBlocksContext";
import MaterialIcon from "../../../../../components/BuilderComponents/MaterialIcon";

const EditFilters = ({ nonSelectedFilter, setNonSelectedFilter }) => {
  const { recordsviewLayout, setRecordsviewLayout } = useAppBlocksContext();

  const modifyListviewLayout = (action, index) => {
    let layoutCopy = { ...recordsviewLayout };

    let nonSelectedCopy = [...nonSelectedFilter];

    if (action === "add") {
      const fieldObj = nonSelectedCopy[index];
      layoutCopy.onscreen_filters.push(fieldObj);
      const newArray = nonSelectedCopy.filter((_, i) => i !== index);
      nonSelectedCopy = newArray;
    } else if (action === "remove") {
      const removedItem = layoutCopy.onscreen_filters[index];

      //on removal multi select will  be reset
      removedItem.is_multi_select = false;

      const newArray = layoutCopy.onscreen_filters.filter((_, i) => i !== index);
      layoutCopy.onscreen_filters = newArray;
      nonSelectedCopy.push(removedItem);
    }

    setNonSelectedFilter(nonSelectedCopy);
    setRecordsviewLayout(layoutCopy);
  };

  const multiSelectHandler = (listType, isChecked, index) => {
    if (listType === "added") {
      const newLayout = { ...recordsviewLayout };
      newLayout.onscreen_filters[index].is_multi_select = isChecked;

      setRecordsviewLayout(newLayout);
    } else if (listType === "non added") {
      const newArray = [...nonSelectedFilter];
      newArray[index].is_multi_select = isChecked;
      setNonSelectedFilter(newArray);
    }
  };

  return (
    <>
      <EditFilter
        recordsviewLayout={recordsviewLayout}
        nonSelectedFilter={nonSelectedFilter}
        modifyListviewLayout={modifyListviewLayout}
        multiSelectHandler={multiSelectHandler}
      />
    </>
  );
};

export default EditFilters;

const EditFilter = ({ recordsviewLayout, nonSelectedFilter, modifyListviewLayout, multiSelectHandler }) => {
  const multiSelect = (type, index, isChecked) => (
    <div key={type + index.toString()} className="builder_checkbox_outer ">
      <Input
        onChange={(e) => {
          multiSelectHandler(type, e.target.checked, index);
        }}
        id="multi"
        type="checkbox"
        checked={isChecked}
      />
      <label htmlFor="multi">Multi Select Filter</label>
    </div>
  );

  return (
    <div className="edit_popup_inside">
      {recordsviewLayout.onscreen_filters?.map((field, index) => (
        <div key={field.id} className="Recordsview_column_list selected">
          <div>
            {field.prefix}.{field.display || field.name}
          </div>
          <div className="edit_add_and_multi_container">
            {multiSelect("added", index, field?.is_multi_select)}
            <MaterialIcon
              name="delete"
              className="delete_icon ml_4"
              onClick={() => modifyListviewLayout("remove", index)}
            />
          </div>
        </div>
      ))}

      {nonSelectedFilter?.map((field, index) => (
        <div key={field.id} className="Recordsview_column_list">
          <div>
            {field.prefix}.{field.display || field.name}
          </div>

          <div className="edit_add_and_multi_container">
            {multiSelect("non added", index, field?.is_multi_select)}

            <MaterialIcon name="add" className="edit_icon ml_4" onClick={() => modifyListviewLayout("add", index)} />
          </div>
        </div>
      ))}
    </div>
  );
};
